import axios from 'axios'
import store from '@/store'
import { Message } from 'element-ui'
const service = axios.create({
  baseURL: window._env_.VUE_APP_BRAINS_API,
  timeout: 15000 // request timeout
})

service.interceptors.request.use(
  config => {
    config.headers['Authorization'] = 'Bearer ' + store.state.user.token
    return config
  },
  error => {
    // do something with request error
    console.error(error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response.status !== 200) {
      // debugger
    }
    const res = response
    // const res = response.data
    /*
    if (res.code && res.code !== 20000) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
    }
    */
    return res
  },
  error => {
    // console.log('err' + error) // for debug
    if (error.response.status === 401) {
      // debugger
      Message({
        message: 'Session Out, please refresh page',
        type: 'error',
        duration: 5 * 1000
      })
      console.error(error)
      document.location.reload()
    }
    return Promise.reject(error)
  }
)

export default service
